import type { AuthorPostsResponse } from "./types";

export async function fetchAuthorPosts(uuid: string, page: number): Promise<AuthorPostsResponse> {
  const res = await fetch(`/api/author/${uuid}/posts?page=${page}`);
  if (!res.ok) throw new Error("Failed to fetch posts");
  return res.json();
}
